// Logika murni pengaman upload mockup (tanpa AI). Dipakai upload_guard.jsx + Jest.
export const REASON_MIN = 5;
export const GUARD_CODES = ["UPLOAD_GUARD_CONFIRM", "UPLOAD_DUPLICATE", "VERSION_CONFLICT"];

// Asisten nomor pesanan: hanya indikator/peringatan, tidak pernah menolak upload.
export function orderNoCheckNotice(res) {
  const c = res?.data?.order_no_check;
  if (!c || !c.id) return null;
  const found = (c.detected || []).join(", ") || "-";
  if (c.status === "cocok") return { kind: "ok", id: c.id, message: `Nomor pesanan COCOK: ${c.expected}` };
  if (c.status === "berbeda") return { kind: "warn", id: c.id, title: "Periksa nomor pesanan",
    message: `Nomor di gambar berbeda. Sistem: ${c.expected} · Terbaca di gambar: ${found}. Mockup tetap tersimpan — pastikan file untuk pesanan yang benar.` };
  if (c.status === "perlu_pemeriksaan") return { kind: "warn", id: c.id, title: "Periksa nomor pesanan secara manual",
    message: `Nomor pesanan ${c.expected} belum dapat dipastikan (${c.reason || "tidak terbaca"}). Terbaca: ${found}. Mockup tetap tersimpan.` };
  return null;
}

export function canProceed(check, ack, reason) {
  if (!check || check.blocked) return false;
  if (!check.needs_confirm) return true;
  return !!ack && String(reason || "").trim().length >= REASON_MIN;
}

export function guardParams(check, ack, reason) {
  if (!check?.needs_confirm || !ack) return {};
  return { guard_ack: "1", guard_reason: String(reason || "").trim() };
}

export function withQuery(url, params) {
  const q = new URLSearchParams(params || {}).toString();
  if (!q) return url;
  return url + (url.includes("?") ? "&" : "?") + q;
}

export function guardErrorCode(e) {
  const d = e?.response?.data?.detail;
  if (e?.response?.status !== 409 || !d || typeof d !== "object") return null;
  return GUARD_CODES.includes(d.code) ? d.code : null;
}

export function guardErrorMessage(e) {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object" && d.message) return d.message;
  if (typeof d === "string" && d.trim()) return d;
  return e?.message || "Terjadi kesalahan.";
}

export function precheckErrorMessage(e) {
  const st = e?.response?.status;
  if (st === 403) return "Anda tidak berwenang mengunggah ke pesanan ini.";
  if (st === 423 || st === 400) return guardErrorMessage(e);
  if (!e?.response) return "Pemeriksaan file gagal: server tidak dapat dihubungi. File BELUM dianggap aman — coba lagi.";
  return `Pemeriksaan file gagal (${st}). File BELUM dianggap aman — coba lagi.`;
}

// Modal pengaman perlu ditampilkan bila belum ada pratinjau, atau ada peringatan apa pun.
export function needsModal(check, previewShown) {
  return !previewShown || !check || (check.warnings || []).length > 0;
}

export async function sha256Hex(file) {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) throw new Error("Browser tidak mendukung pemeriksaan file (SHA-256). Gunakan Chrome/Edge terbaru melalui HTTPS.");
  const buf = await file.arrayBuffer();
  const hash = await subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, "0")).join("");
}
